export class InventoriesParameters {    
    store?: string;    
    city?: string;
    businessGroup?: string;
    serialNumber: string;
    from: Date;
    to: Date;
    last: boolean;
    selectedTimeRange: string;
    parentNotificationId? : number;
    productSku : string;
}